import {SignalREvent, ViewMode} from 'constants/dataEnum';
import {kickSession} from '../sessionBusiness';

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  hubObject.on(SignalREvent.USER_UPDATED, (args) => {
    console.info('event received:', SignalREvent.USER_UPDATED);
    console.log(SignalREvent.USER_UPDATED, args);

    const state = getState();
    const {appState, sessionState} = state;
    const {user} = sessionState;

    if (appState.viewMode === ViewMode.LOGIN) {
      return;
    }

    if (user?.userId !== args) {
      return;
    }

    dispatch(kickSession());
  });
};

export default subscribeEvent;
